import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/aceexams.css';
import { FiCheckCircle, FiArrowRight } from 'react-icons/fi';

const AceExams = () => {

const [isLogin, setIsLogin] = useState(false);

  useEffect(() => {
    try {
      const itemStr = localStorage.getItem('isLogin');
      const parsed = itemStr ? JSON.parse(itemStr) : null;
      if (parsed && parsed.expiry && parsed.expiry > Date.now()) {
        setIsLogin(true);
      } else {
        setIsLogin(false);
      }
    } catch {
      setIsLogin(false);
    }
  }, []);

  return (
    <section className="ace-exams-section">
      <h2 className="ace-heading">Ready to Ace Your Next Exam?</h2>
      <p className="ace-subheading">
        Join thousands of successful test-takers who prepared with Poly Quizz. Start practicing today and gain the confidence you need to succeed.
      </p>

      <div className="ace-feature-cards">
        <div className="ace-card">
          <FiCheckCircle className="ace-icon" />
          <h3>Realistic Simulations</h3>
          <p>Practice in an environment that mirrors your actual exam experience</p>
        </div>
        <div className="ace-card">
          <FiCheckCircle className="ace-icon" />
          <h3>Detailed Analytics</h3>
          <p>Track your progress and identify areas for improvement</p>
        </div>
        <div className="ace-card">
  <FiCheckCircle className="ace-icon" />
  <h3>Detailed Explanations</h3>
  <p>Understand every answer with clear, step-by-step explanations for all questions.</p>
</div>
      </div>

      <div className="ace-buttons">
         {!isLogin && (
                    <Link
  to="/register"
  onClick={() => {
    window.scrollTo(0, 0);
  }}
>
  <button className="btn-primary-ace">
    Start Free Trial
  </button>
</Link>
         )}
         <Link to="/all-exam-prep-practice-test"> 
        <button className="btn-outline-ace">
          View All Exams <FiArrowRight />
        </button></Link>
        
      </div>
    </section>
  );
};

export default AceExams;
